import { compose } from '@reduxjs/toolkit';
import { withTranslation } from 'react-i18next';

import CardStatusTag from './CardStatusTag.layout';


const decorate = compose(withTranslation('transactions'));

export default decorate(CardStatusTag);
